import { NotAuthorized } from "_shared/_errors/_views/not-authorized";
import { RootState, useAttorneyHubDispatch } from "_shared/_stores/redux-store";
import CompanyBookmarks from "marketplace/bookmarks/company-bookmarks/_views/company-bookmarks-table";
import IndividualBookmarks from "marketplace/bookmarks/individual-bookmarks/_views/individual-bookmarks-table";
import TeamBookmarks from "marketplace/bookmarks/team-bookmarks/_views/team-bookmarks-table";
import { getSessionPermissions, populateSessionPermissions } from "permissions/_stores/permissions-redux-slice";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLoaderData } from "react-router";
import { useSession } from "users/__session/session-context";
import { PageTab } from "./bookmarks-page-tabs";
import Loader from "_shared/_views/loading/loader";
import Box from "@mui/material/Box";
import { styled } from "@mui/material";

const LoaderContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
}));

export default function Bookmarks() {
  const route = useLoaderData();
  const activeTab = route.pageTab ?? PageTab.Individual;

  const session = useSession();
  const dispatch = useAttorneyHubDispatch();
  const sessionPermissions = useSelector(getSessionPermissions);
  const sessionPermissionsLoading = useSelector((state: RootState) => state.permissions.session.loading);
  const sessionPermissionsError = useSelector((state: RootState) => state.permissions.session.error);

  useEffect(() => {
    if (!sessionPermissions && !sessionPermissionsError && !sessionPermissionsLoading) {
      dispatch(populateSessionPermissions({ session }));
    }
  }, [dispatch, session, sessionPermissions, sessionPermissionsError, sessionPermissionsLoading]);

  if (!sessionPermissions)
    return (
      <LoaderContainer>
        <Loader fontSize="20px" />
      </LoaderContainer>
    );
  if (!sessionPermissions?.includesReadAccessToMarketplace) return <NotAuthorized />;

  switch (activeTab) {
    case PageTab.Individual:
      return <IndividualBookmarks activeTab={activeTab} />;
    case PageTab.Team:
      return <TeamBookmarks activeTab={activeTab} />;
    case PageTab.Company:
      return <CompanyBookmarks activeTab={activeTab} />;
    default:
      return <IndividualBookmarks activeTab={activeTab} />;
  }
}
